import request from "@/CommonDP/utils/request";

export function serveReadExcel(data) {
  return request({ method: 'post', url: 'dyn-common/readFromExcel', data });
}
// listPageId：列表页ID
// queryMatchFieldMap：条件匹配字段；excel字段->表字段
// updateMatchFieldMap：更新字段；excel字段->表字段
// unmatchedProcessingStrategy：无匹配记录处理方式；1：中止并报错；2：忽略
// dataList：
export function preExcelData(data) {
  return request({ method: 'post', url: 'dyn-common/importForUpdate/simulateImport', data });
}
export function savaExcelData(data) {
  return request({ method: 'post', url: 'dyn-common/importForUpdate/doImport', data });
}
export function getMetaColumn(data) {
  return request({ url: 'dyn-list/mainMeta/queryColumns', params: data });
}
